"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentationUrlFromHeaders = exports.parseHydraDocumentation = exports.fetchJsonLd = void 0;
var fetchJsonLd_1 = require("./fetchJsonLd");
Object.defineProperty(exports, "fetchJsonLd", { enumerable: true, get: function () { return __importDefault(fetchJsonLd_1).default; } });
var parseHydraDocumentation_1 = require("./parseHydraDocumentation");
Object.defineProperty(exports, "parseHydraDocumentation", { enumerable: true, get: function () { return __importDefault(parseHydraDocumentation_1).default; } });
Object.defineProperty(exports, "getDocumentationUrlFromHeaders", { enumerable: true, get: function () { return parseHydraDocumentation_1.getDocumentationUrlFromHeaders; } });
//# sourceMappingURL=index.js.map